import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;

@Component({
  selector: "app-goal-params-list",
  templateUrl: "./goal-params-list.component.html",
  styleUrls: ["./goal-params-list.component.css"],
})
export class GoalParamsListComponent implements OnInit {
  constructor(private router: Router, private http: HttpService) {}

  public data: any = [];

  ngOnInit() {
    this.getData();
  }

  public getData(isSearch = false) {
    this.http.getData(API.goalParameter).then((res) => {
      this.data = res.data;
    });
  }

  public edit(id: number) {
    this.router.navigate(["index/goalParameter", id]);
  }

  public del(id) {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.deleteData(API.goalParameter + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/goal-params-list/goal-params-list.component.ts